import React, { FC, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PurchaseRequestForm from '../purchase_request_form/PurchaseRequestForm';
import { purchaseRequestsRestCrudThunksForSupplier } from '../../thunks/purchase_requests_thunks';
import { EditPage } from '../edit_page/EditPage';
import { getEntityById } from '../../utils/DataAccessUtils';
import { PURCHASE_REQUESTS_CRUD_ACTION_CREATORS } from '../../actions/purchase_requests_actions';

require('./EditPurchaseRequestPage.less');

const EditPurchaseRequestPage: FC<any> = ({
	getPurchaseRequest,
	match,
	history,
	purchaseRequest,
	fetching,
	removePRFromRedux,
}): React.ReactElement => {
	useEffect(() => {
		const id = match.params.id;
		getPurchaseRequest(id);
	}, [getPurchaseRequest, match.params.id]);

	const onSuccess = useCallback(
		(record) => {
			removePRFromRedux(record);
			history.push(`/supplier/purchaseRequests/detail/${record.id}`);
		},
		[history, removePRFromRedux]
	);

	return (
		<>
			<EditPage
				title="Edit Purchase Request"
				formComponentProps={{
					formData: purchaseRequest,
					onSuccess,
				}}
				fetching={fetching}
				FormComponent={PurchaseRequestForm}
			/>
			,
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		purchaseRequest: getEntityById(ownProps.match.params.id, state.purchase_requests),
		fetching: state.purchase_requests.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPurchaseRequest: (id) => dispatch(purchaseRequestsRestCrudThunksForSupplier.readOne(id)),
	removePRFromRedux: (entity) =>
		dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.deleteSuccess(entity)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditPurchaseRequestPage));
